<template>
  <v-container>
    <div class="container-inner">
      <v-row>
        <v-col cols="2">
          <v-list>
            <v-list-item @click="showUserProfileSection">
              <v-list-item-title>User Profile</v-list-item-title>
            </v-list-item>
            <v-list-item @click="showSubscriptionSection">
              <v-list-item-title>Subscription</v-list-item-title>
            </v-list-item>
            <v-list-item @click="showGeneralSettingsSection">
              <v-list-item-title>Preferences</v-list-item-title>
            </v-list-item>
            <v-list-item @click="showCustomFieldsSection">
              <v-list-item-title>Custom Fields</v-list-item-title>
            </v-list-item>
            <v-list-item class="active-menu-item">
              <v-list-item-title>User Roles</v-list-item-title>
            </v-list-item>
          </v-list>
        </v-col>
        <v-col cols="10" style="border-left: 1px solid #efefef; min-height: 70vh">
          <div class="px-8">
            <router-view />
          </div>
        </v-col>
      </v-row>
    </div>
  </v-container>
</template>

<script>
import {
  SETTINGS_PAGE_GENERAL_SETTINGS,
  SETTINGS_PAGE_SUBSCRIPTION,
  SETTINGS_PAGE_CUSTOM_FIELDS,
  SETTINGS_PAGE_SUBSCRIPTION_MANAGE_PLANS,
  SETTINGS_PAGE_USER_PROFILE
} from '../../constant'
import {
  MODULE_SETTINGS,
  MODULE_USER
} from '../../store/constant/mutation-types'
export default {
  name: 'UsersRoles',
  computed: {
    user() {
      return this.$store.getters[`${MODULE_USER}/user`]
    },
    currentSettingsPageSection() {
      return this.$store.getters[`${MODULE_SETTINGS}/getSettingsPageSection`]
    }
  },
  methods: {
    showUserProfileSection() {
      this.$store.dispatch('setSettingsPageSection', SETTINGS_PAGE_USER_PROFILE)
      this.$router.push({ name: 'UserSettings' })
    },
    showSubscriptionSection() {
      this.$store.dispatch('setSettingsPageSection', SETTINGS_PAGE_SUBSCRIPTION)
      this.$router.push({ name: 'UserSettings' })
    },
    showGeneralSettingsSection() {
      this.$store.dispatch(
        'setSettingsPageSection',
        SETTINGS_PAGE_GENERAL_SETTINGS
      )
      this.$router.push({ name: 'UserSettings' })
    },
    showCustomFieldsSection() {
      this.$store.dispatch(
        'setSettingsPageSection',
        SETTINGS_PAGE_CUSTOM_FIELDS
      )
      this.$router.push({ name: 'UserSettingsCustomField' })
    },
    showSubscriptionManagePlans() {
      this.$store.dispatch(
        'setSettingsPageSection',
        SETTINGS_PAGE_SUBSCRIPTION_MANAGE_PLANS
      )
      this.$router.push({ name: 'UserSettings' })
    }
  }
}
</script>

<style scoped lang="scss">
.container-inner {
  padding-left: 0;
  padding-right: 0;
}
.v-list-item__title {
  font-size: 14px;
}
.v-list-item {
  position: relative;
  border-radius: 0;
  min-height: 38px;
  margin-bottom: 8px;
  .v-list-item__title {
    overflow: visible !important;
  }
  &:hover {
    background-color: rgba(0, 0, 0, 0.05);
  }
  &.active-menu-item {
    background-color: rgba(0, 0, 0, 0.05);
  }
}
</style>
